import React, { useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTheme } from "@mui/material/styles";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import {
  Dashboard,
  Group,
  Assignment,
  School,
  Menu,
} from "@mui/icons-material";
const drawerWidth = 240;

const MENU = [
  {
    name: "대시보드",
    path: "",
    auth: ["admin"],
  },
  { name: "스터디", path: "study", auth: ["admin"] },
  { name: "유저", path: "user", auth: ["admin"] },
  { name: "학생", path: "student", auth: ["admin"] },

  { name: "어젠다", path: "agenda", auth: ["admin"] },
  { name: "과제", path: "assignment", auth: ["admin", "ta"] },
  { name: "TA", path: "ta", auth: ["admin"] },
];
const AdminLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  if (currentUser.role === "student") {
    navigate("/");
  }

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawerContent = (
    <List>
      {MENU.map((item, index) => {
        if (!item.auth.includes(currentUser.role)) {
          return null;
        }

        return (
          <ListItem
            button
            key={item.name}
            component={Link}
            to={`/admin/${item.path.toLowerCase()}`}
          >
            <ListItemIcon>
              {index === 0 ? (
                <Dashboard />
              ) : index === 1 ? (
                <Group />
              ) : index === 2 ? (
                <Assignment />
              ) : (
                <School />
              )}
            </ListItemIcon>
            <ListItemText primary={item.name} />
          </ListItem>
        );
      })}
    </List>
  );

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      {isMobile && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            padding: "8px",
            backgroundColor: "white",
            zIndex: 1100,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </div>
      )}

      <div style={{ display: "flex", flex: 1 }}>
        <Drawer
          variant={isMobile ? "temporary" : "permanent"}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          style={{ width: drawerWidth }}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            style: {
              width: drawerWidth,
              marginTop: isMobile ? "56px" : 0, // 모바일에서 상단 헤더 높이만큼 여백 추가
            },
          }}
        >
          {drawerContent}
        </Drawer>
        <main
          style={{
            flexGrow: 1,
            padding: "20px",
            marginTop: isMobile ? "56px" : 0, // 모바일에서 상단 헤더 높이만큼 여백 추가
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
